"use client";
import React from "react";
import TradeList from "modules/swap-calculator/components/lists/TradeList";
import { useSwapLists } from "modules/swap-calculator/stores/useSwapCalculatorStore";

function ListContainer() {
  // Optimal Zustand selector - only re-renders when lists change
  const { leftCards, rightCards } = useSwapLists();

  return (
    <div className="mt-4 flex w-full gap-2">
      <TradeList list={leftCards} />
      <TradeList list={rightCards} />
    </div>
  );
}

export default ListContainer;
